import React from 'react'
import {Marker} from 'react-leaflet';
import connect from "react-redux/es/connect/connect";

let latLng = null;

const handleMove = (marker) => {
    latLng = marker.latlng;
};

const handleDragPolygon = (id, pollutionAreas, updatePollutionArea) => {

    let coordinates = pollutionAreas.coordinates[0].map((coords, key) => {
        if (key === id) {
            return [latLng.lat, latLng.lng];
        } else {
            return coords;
        }
    });

    if (id === coordinates.length - 1)
        coordinates[0] = coordinates[id];

    let types = pollutionAreas.layers.map(type => {
        return type.layer;
    });

    let pollutionArea = {
        location: {
            points: [coordinates],
            type: "Polygon"
        },
        name: pollutionAreas.map,
        types: types
    };

    updatePollutionArea(pollutionArea);

    return 0
};

const Polygon = (props) => {

    let coord = props.pollutionAreas.coordinates[0];

    return (
        <div>
            {coord.map((position, key) => {
                if (key !== 0) {
                    return (
                        <Marker
                            key={key}
                            onClick={() => {
                                if ((coord[0][0] === position[0]) && (coord[0][1] === position[1])
                                    && (props.pollutionAreas.lineStringCoordinates.length > 2)) {
                                    props.closePollutionArea()
                                }
                            }}
                            position={position}
                            draggable={true}
                            onMove={handleMove}
                            onDragEnd={() => handleDragPolygon(key, props.pollutionAreas, props.updatePollutionArea)}>
                        </Marker>);
                }
                return null;
            })}
        </div>
    );

};

const mapStateToProps = (state) => {
    return {
        pollutionAreas: state.pollutionAreas,
    }
};

export default connect(mapStateToProps, null)(Polygon)


// WEBPACK FOOTER //
// ./src/components/Map/MapComponents/Polygon.js